<h2 class="form__title">Document Properties</h2>

<form novalidate class="form__cont">
  <h3 class="full__section">Document Information</h3>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Document Class</mat-label>
      <input matInput placeholder="Placeholder"
        [value]="doc?.propertiesObj?.ClassDescription | asyncChoiceList:objectStore:'ACLDocumentClasses' | async"
        disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Contract Identifier</mat-label>
      <input matInput placeholder="Placeholder" [value]="doc?.propertiesObj?.ContractIdentifier" disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Type of Agreement</mat-label>
      <input matInput placeholder="Placeholder"
        [value]="doc?.propertiesObj.ContractAgreementType | asyncChoiceList:objectStore:'ContractAgreementTypes' | async"
        disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Contract Status</mat-label>
      <input matInput placeholder="Placeholder"
        [value]="doc?.propertiesObj.ContractStatus | asyncChoiceList:objectStore:'ContractStatuses' | async" disabled />
    </mat-form-field>
  </div>

  <div class="form-container full__section">
    <mat-form-field appearance="outline">
      <mat-label>Contract Name</mat-label>
      <input matInput placeholder="Placeholder" [value]="doc?.propertiesObj.DocumentTitle" disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>CMSID</mat-label>
      <input matInput placeholder="Placeholder"
        [value]="doc?.propertiesObj?.ContractCMSID ? doc?.propertiesObj?.ContractCMSID : ''" disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Document Type</mat-label>
      <input matInput placeholder="Placeholder"
        [value]="doc?.propertiesObj.ContractType | asyncChoiceList:objectStore:'ContractTypes' | async" disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Location of Wet Ink</mat-label>
      <input matInput placeholder="Placeholder"
        [value]="doc?.propertiesObj?.ContractWetInk ? doc?.propertiesObj?.ContractWetInk : ''" disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Contract Parties</mat-label>
      <input matInput placeholder="Placeholder" [value]="doc?.propertiesObj?.ContractParties" disabled />
    </mat-form-field>
  </div>


  <h3 class="full__section">Document Dates and Deadlines</h3>

  <!-- {{doc.propertiesObj.ContractStartDate}} -->
  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Contract Start Date</mat-label>
      <input matInput placeholder="Placeholder" [value]="doc?.propertiesObj.ContractStartDate | aspenDate" disabled />
    </mat-form-field>
  </div>

  <div class="form-container" *ngIf="!doc?.propertiesObj?.ContractNoAlertRequired">
    <mat-form-field appearance="outline">
      <mat-label>Deadline Date</mat-label>
      <input matInput placeholder="Placeholder" [value]="doc?.propertiesObj.ContractReviewDeadlineDate | aspenDate"
        disabled />
    </mat-form-field>
  </div>

  <div class="form-container"
    *ngIf='doc?.propertiesObj?.ClassDescription === DocumentClasses.Fixed_Term_Contract || doc?.propertiesObj?.ClassDescription === DocumentClasses.Transaction_Contract'>
    <mat-form-field appearance="outline">
      <mat-label>Contract End Date</mat-label>
      <input matInput placeholder="Placeholder" [value]="doc?.propertiesObj.ContractEndDate | aspenDate" disabled />
    </mat-form-field>
  </div>


  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Signature Date</mat-label>
      <input matInput placeholder="Placeholder" [value]="doc?.propertiesObj.ContractDateOfLastSignature | aspenDate"
        disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <section class="custom-check-box-group">
      <mat-checkbox class="custom-check-box" name="ContractNoAlertRequired"
        [(ngModel)]="doc?.propertiesObj.ContractNoAlertRequired" disabled>No Alert Required</mat-checkbox>
    </section>
  </div>


  <ng-container *ngIf="doc?.propertiesObj.ContractBusinessOwner | asyncBusinessOwnerEntity | async as owner">
    <h3 class="full__section">Additional Information</h3>
    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-label>Business Owner</mat-label>
        <input matInput placeholder="Placeholder" [value]="owner.fullname" disabled />
      </mat-form-field>
    </div>

    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-label>Business Owner Email</mat-label>
        <input matInput placeholder="Placeholder" [value]="owner.email" disabled />
      </mat-form-field>
    </div>

    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-label>Business Owner Contact Number</mat-label>
        <input matInput placeholder="Placeholder" [value]="owner.telephone" disabled />
      </mat-form-field>
    </div>

    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-label>Business Owner Department</mat-label>
        <input matInput placeholder="Placeholder" [value]="owner.department" disabled />
      </mat-form-field>
    </div>

    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-label>Business Owner Designation</mat-label>
        <input matInput placeholder="Placeholder" [value]="owner.designation" disabled />
      </mat-form-field>
    </div>
  </ng-container>

  <div class="form-container full__section">
    <mat-form-field appearance="outline">
      <mat-label>Department</mat-label>
      <input matInput placeholder="Placeholder" [value]="doc?.propertiesObj?.ContractDepartment" disabled />
    </mat-form-field>
  </div>

  <ng-container *ngIf="doc?.propertiesObj.ContractLegalCounsel | asyncLegalCounselEntity | async as legalCounsel">
    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-label>Legal Counsel</mat-label>
        <input matInput placeholder="Placeholder" [value]="legalCounsel.fullname" disabled />
      </mat-form-field>
    </div>

    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-label>Legal Counsel Email</mat-label>
        <input matInput placeholder="Placeholder" [value]="legalCounsel.email" disabled />
      </mat-form-field>
    </div>
  </ng-container>

  <h3 class="full__section">Product Data</h3>


  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>UPI</mat-label>
      <input matInput placeholder="Placeholder"
        [value]="doc?.propertiesObj.ContractUPI ? doc?.propertiesObj.ContractUPI : ''" disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <app-multiselect-wrapper label="Products" name="ContractProducts" [(ngModel)]="doc?.propertiesObj.ContractProducts"
      choiceListName="allProducts" gerritServiceName="allProducts" [objectStore]="objectStore" [disabled]="true"
      matTooltip="The drug or substance used to cure, treat, prevent disease or injury, a medicine">
    </app-multiselect-wrapper>
  </div>

  <div class="form-container">
    <app-multiselect-wrapper label="Molecules" name="ContractMolecules"
      [(ngModel)]="doc?.propertiesObj.ContractMolecules" choiceListName="allMolecules" gerritServiceName="allMolecules"
      [objectStore]="objectStore" [disabled]="true" matTooltip="The main component making up the drug(s)">
    </app-multiselect-wrapper>
  </div>

  <div class="form-container">
    <app-multiselect-wrapper label="Territories" name="ContractTerritories"
      [(ngModel)]="doc?.propertiesObj.ContractTerritories" choiceListName="allTerritories"
      gerritServiceName="allTerritories" [objectStore]="objectStore" [disabled]="true"
      matTooltip="The territory or country where the product is distributed"></app-multiselect-wrapper>

  </div>

</form>
